export const ActionTypes = {
  LOADING: "CREATE_DECISION_TEMPLATE_LOADING",
  ERROR: "CREATE_DECISION_TEMPLATE_ERROR",
  SUCCESS: "CREATE_DECISION_TEMPLATE_SUCCESS",
};
